import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param payload
 */
class TallyIntegrationServices {
  /**
   * @param orgId
   * @param {*} payload
   * @return
   */
  getTallyConnections = async (orgId, tallyId) => {
    let url = `${Constants.GET_TALLY_CONNECTIONS}`;
    if (orgId) url += `?org_id=${orgId}&`;
    if (tallyId) url += `it_id=${tallyId}&`;
    const getTallyConnections = await Helpers.get({
      url,
    });
    return getTallyConnections;
  }

    /**
     *
     * @param orgId
     * @return
     */
    connectToTally = async (payload) => {
      const url = `${Constants.CONNECT_TO_TALLY}`;
      const connectToTally = await Helpers.post({
        url,
        data: payload,
      });
      return connectToTally;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    deleteTallyConnection = async (payload) => {
      const url = `${Constants.DELETE_TALLY_CONNECTION}`;
      const deleteTallyConnection = await Helpers.post({
        url,
        data: payload,
      });
      return deleteTallyConnection;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    syncProduct = async (payload) => {
      const url = `${Constants.SYNC_TALLY_PRODUCT}`;
      const syncProduct = await Helpers.post({
        url,
        data: payload,
      });
      return syncProduct;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
     syncVendor = async (payload) => {
       const url = `${Constants.SYNC_TALLY_VENDOR}`;
       const syncVendor = await Helpers.post({
         url,
         data: payload,
       });
       return syncVendor;
     }

     /**
     *
     * @param {*} payload
     * @returns
     */
     syncTallyGRN = async (payload) => {
       const url = `${Constants.SYNC_TALLY_GRN}`;
       const syncTallyGRN = await Helpers.post({
         url,
         data: payload,
       });
       return syncTallyGRN;
     }

     /**
     *
     * @param {*} payload
     * @returns
     */
     syncTallyInvoice = async (payload) => {
       const url = `${Constants.SYNC_TALLY_INVOICE}`;
       const syncTallyInvoice = await Helpers.post({
         url,
         data: payload,
       });
       return syncTallyInvoice;
     }

     /**
     *
     * @param {*} payload
     * @returns
     */
    syncTallyCreditNote = async (payload) => {
      const url = `${Constants.SYNC_TALLY_CN}`;
      const syncTallyCreditNotes = await Helpers.post({
        url,
        data: payload,
      });
      return syncTallyCreditNotes;
    }

     /**
     *
     * @param {*} payload
     * @returns
     */
     syncPO = async (payload) => {
       const url = `${Constants.SYNC_TALLY_PO}`;
       const syncPO = await Helpers.post({
         url,
         data: payload,
       });
       return syncPO;
     }

     /**
     *
     * @param {*} payload
     * @returns
     */
    syncDN = async (payload) => {
      const url = `${Constants.SYNC_TALLY_DN}`;
      const syncDN = await Helpers.post({
        url,
        data: payload,
      });
      return syncDN;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    pullTallyProducts = async (payload) => {
      const url = `${Constants.PULL_TALLY_PRODUCTS}`;
      const pullTallyProducts = await Helpers.post({
        url,
        data: payload,
      });
      return pullTallyProducts;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    pullTallyVendors = async (payload) => {
      const url = `${Constants.PULL_TALLY_VENDORS}`;
      const pullTallyVendors = await Helpers.post({
        url,
        data: payload,
      });
      return pullTallyVendors;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    pullTallyVendorPayment = async (payload) => {
      const url = `${Constants.PULL_TALLY_VENDOR_PAYMENT}`;
      const pullTallyVendorPayment = await Helpers.post({
        url,
        data: payload,
      });
      return pullTallyVendorPayment;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    connectTenantToTallyLocation = async (payload) => {
      const url = `${Constants.CONNECT_TENANT_TO_TALLY_LOCATION}`;
      const connectTenantToLocationTallyData = await Helpers.post({
        url,
        data: payload,
      });
      return connectTenantToLocationTallyData;
    }

    /**
     *
     * @param {*} payload
     * @returns
     */
    refreshTallyConnections = async (payload) => {
      const url = `${Constants.REFRESH_TALLY_CONNECTIONS}`;
      const refreshTallyConnections = await Helpers.post({
        url,
        data: payload,
      });
      return refreshTallyConnections;
    }

    pullTallyCustomers = async (payload) => {
      const url = `${Constants.PULL_TALLY_CUSTOMERS}`;
      const pullTallyCustomers = await Helpers.post({
        url,
        data: payload,
      });
      return pullTallyCustomers;
    }

    /**
     *
    * @param {*} payload
    * @returns
    */
    syncTallyDocuments = async (payload) => {
      const url = `${Constants.SYNC_TALLY_DOCUMENTS}`;
      const syncTallyDocuments = await Helpers.post({
        url,
        data: payload,
      });
      return syncTallyDocuments;
    }

    /**
     *
    * @param {*} payload
    * @returns
    */
    updateTallyDocuments = async (payload) => {
      const url = `${Constants.UPDATE_TALLY_EXCLUDED_DOCUMENTS}`;
      const updateTallyDocuments = await Helpers.put({
        url,
        data: payload,
      });
      return updateTallyDocuments;
    }

    /**
     * @param orgId
     * @param {*} payload
     * @return
     */
    getTallyDocuments = async (tenantIds, documentType, startDate, endDate, page, limit, entityName) => {
      let url = `${Constants.GET_TALLY_DOCUMENTS}`;
      if (tenantIds) url += `?tenant_ids=${tenantIds}&`;
      if (documentType) url += `document_type=${documentType}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `end_date=${endDate}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (entityName) url += `entity_name=${entityName}&`;
      const getTallyDocuments = await Helpers.get({
        url,
      });
      return getTallyDocuments;
    }

    /**
     * @param orgId
     * @param {*} payload
     * @return
     */
    getTallyUnMappedDocuments = async (tenantIds, startDate, endDate, page, limit) => {
      let url = `${Constants.GET_TALLY_UNMAPPED_DOCUMENTS}`;
      if (tenantIds) url += `?tenant_ids=${tenantIds}&`;
      if (startDate) url += `from_date=${startDate}&`;
      if (endDate) url += `end_date=${endDate}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      const getTallyUnMappedDocuments = await Helpers.get({
        url,
      });
      return getTallyUnMappedDocuments;
    }

    getTallyDocumentsCount = async (tenantIds) => {
      let url = `${Constants.TALLY_DOCUMENTS_COUNT}`;
      if (tenantIds) url += `?tenant_ids=${tenantIds}&`;
      const getTallyDocumentsCount = await Helpers.get({
        url,
      });
      return getTallyDocumentsCount;
    }
}
export default new TallyIntegrationServices();
